export const RedirectToHome = () => {
  window.location.href = 'https://www.lithodomos.com';

  return null;
};
